import { render } from "./ScheduleConfigSkeleton.vue?vue&type=template&id=c594ee2e&scoped=true"
const script = {}

import "./ScheduleConfigSkeleton.vue?vue&type=style&index=0&id=c594ee2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c594ee2e"]])

export default __exports__